import { Directive, OnInit, Input, ElementRef } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';
import { IAnalytics } from '../interfaces/analytics.interface';


@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[analytics]'
})
export class AnalyticsDirective implements OnInit {
    @Input() analytics: IAnalytics;

    constructor(private element: ElementRef, private analyticsService: AnalyticsService) { }

    ngOnInit() {
        this.element.nativeElement.addEventListener('click', () => {
            this.analyticsService.push(this.analytics);
        });
    }
}
